module.exports = __webpack_public_path__ + "static/media/seswater.10a7ee42.png";